<template>
  <div class="w-full">
    <section
      :class="[
        ' px-4 py-3 w-full rounded-tl-3xl rounded-tr-3xl hover:opacity-75 break-words',
        userDetails && dmInfo && userDetails.providerId !== dmInfo.sender_id
          ? 'mr-auto bg-gray-300 rounded-br-3xl '
          : 'ml-auto bg-blue-500 text-white rounded-bl-3xl',
      ]"
      v-html="twitterText"
    ></section>
    <div v-if="dmInfo.message_data.entities && dmInfo.message_data.entities.urls[0]">
      <a
        v-for="(urlData, index) in dmInfo.message_data.entities.urls"
        :key="index + 'url'"
        :href="urlData.url"
        target="_blank"
        >{{ urlData.url }}</a
      >
    </div>
    <!-- all entities -->
    <div
      v-if="
        dmInfo.message_data.entities && dmInfo.message_data.entities.urls.length
      "
      class="relative"
    >
      <spinner
        :loading="
          dmInfo.message_data.entities &&
          dmInfo.message_data.entities.urls.length &&
          !urlData.length
        "
      />
      <section
        v-for="(urlDetails, index) in urlData"
        :key="index"
        class="shadow-md rounded-md p-2 mt-5"
      >
        <section class="flex" v-if="urlDetails.provider !== 'Twitter'">
          <div class="h-24 mr-2 flex-none">
            <img
              :src="urlDetails.image"
              :alt="urlDetails.title"
              class="w-full h-full rounded-md object-contain"
            />
          </div>
          <div>
            <a
              :href="urlDetails.url"
              target="_blank"
              class="text-base font-medium"
              >{{ urlDetails.title }}</a
            >
            <p class="text-sm">{{ urlDetails.description }}</p>
          </div>
        </section>
        <!-- twitter provider body  -->
        <section
          class=""
          v-if="urlDetails.provider === 'Twitter' && urlDetails.user"
        >
          <!-- header section start -->
          <section class="flex items-center">
            <div
              v-if="urlDetails.provider === 'Twitter'"
              class="h-10 w-10 rounded-full mr-2 flex-none"
            >
              <img
                :src="urlDetails.user.profile_image_url_https"
                :alt="urlDetails.user.screen_name"
                class="w-full h-full object-contain rounded-full"
              />
            </div>
            <p class="text-sm mb-0 mr-2">{{ urlDetails.user.name }}</p>
            <a
              :href="urlDetails.user.screen_name"
              target="_blank"
              class="text-base font-medium mr-5"
              >@{{ urlDetails.user.screen_name }}</a
            >
            <a
              class="text-base"
              :href="`https://twitter.com/${urlDetails.user.screen_name}/status/${dmInfo.id_str}`"
              target="_blank"
            >
              {{ urlDetails.created_at | moment }}
            </a>
          </section>
          <p class="text-base">
            {{ urlDetails.text }}
          </p>
        </section>
        <!-- url details for not visible post  -->
        <section class="flex" v-if="urlDetails.provider === 'Twitter'">
          <a
            v-for="(data, index) in dmInfo.message_data.entities.urls"
            :key="index + 'url'"
            :href="data.expanded_url"
            target="_blank"
            class="text-base"
          >
            {{ data.expanded_url }}
          </a>
        </section>
      </section>
    </div>
    <section
      v-if="
        dmInfo.extended_entities &&
        dmInfo.extended_entities.media &&
        dmInfo.extended_entities.media.length
      "
      class="mt-5"
    >
      <div
        class="mt-5"
        v-for="(mediaData, index) in dmInfo.extended_entities.media"
        :key="index"
      >
        <img :src="mediaData.media_url_https" class="object-contain h-56" />
      </div>
    </section>
    <h4
      :class="[
        'text-xs mt-1 mb-0 text-gray-600',
        userDetails && dmInfo && userDetails.providerId !== dmInfo.sender_id
          ? 'mr-auto text-left'
          : 'ml-auto text-right',
      ]"
    >
      {{ dmInfo && dmInfo.dm_created_timestamp | moment }}
    </h4>
  </div>
</template>

<script>
import moment from 'moment';
import axiosApi from '../../services/inteceptor';
import utils from '@/services/utils';

const API_USER_INFO = `${utils.svcUrl()}connect`;

export default {
  name: 'MessageContainer',
  props: [
    'dmInfo',
    'acctUsername',
    'providerId',
    'profilePic',
    'userName',
    'handleNextCallback',
    'handlePrevCallback',
    'isFirst',
    'currentDm',
  ],
  data() {
    return {
      twitterText: '',
      urlData: [],
      memberProviderId: this.dmInfo?.conversation_id.split('_')[1],
    };
  },
  computed: {
    createdAt() {
      return new Date(Number(this.dmInfo?.dm_created_timestamp));
    },
    userDetails() {
      return this.$store.state.userDetails;
    },
    myDmCounts: {
      get() {
        const { dmCounts } = this.$store.state.connect;
        const myCount = dmCounts.find(
          (data) => data.conversation_id === this.dmInfo?.conversation_id,
        );
        return myCount?.totalCount;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  mounted() {
    this.changeTweetText();
    this.fetchMeta();
    if (!this.userDetails?.providerId) {
      this.$store.dispatch('getMyDetails', {});
    }
  },
  watch: {
    dmInfo(newInfo, oldInfo) {
      if (newInfo !== oldInfo) {
        this.changeTweetText();
        this.urlData = [];
        this.fetchMeta();
        this.memberProviderId = this.dmInfo?.conversation_id.split('_')[1];
      }
    },
  },
  methods: {
    changeTweetText() {
      let tempText = this.dmInfo?.message_data?.text;
      if (this.dmInfo?.message_data?.entities) {
        if (this.dmInfo.message_data?.entities?.media) {
          tempText = tempText.replace(
            this.dmInfo.message_data?.entities.media[0].url,
            '',
          );
        }
        if (this.dmInfo?.message_data?.entities?.urls?.length) {
          tempText = tempText.replace(
            this.dmInfo.message_data?.entities.urls[0].url,
            '',
          );
        }
      }
      this.twitterText = tempText?.replace(/\n/g, '<br />');
    },
    async fetchMeta() {
      if (this.dmInfo?.message_data?.entities?.urls?.length) {
        const response = await axiosApi.post(
          `${API_USER_INFO}/get-web-preview`,
          {
            entities: this.dmInfo?.message_data?.entities?.urls,
          },
        );
        this.urlData = response?.data;
        // console.log({ urlData: this.urlData });
      }
    },
  },
  filters: {
    moment: (date) => moment(date).format('MMMM Do YYYY, h:mm a'),
  },
};
</script>

<style>
</style>
